import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Loader from '@/components/loader/Loader.vue'

export default {
    name: 'modal-page',
    data () {
        return {
            content: '',
            loaded: false,
        }
    },
    props: {
        name: {
            String,
            required: true
        },
        title: {
            type: String,
        },
    },
    mounted() {
        if (this.show)
            this.getPage()
    },
    components: {
        VuePerfectScrollbar,
        Loader
    },
    computed: {
        show() {
            return this.$route.query.modal === this.name
        }
    },
    watch: {
        show(value) {
            this.loaded = false

            if (value) {
                this.getPage()
            }
        }
    },
    methods: {
        getPage() {
            setTimeout(() => {
                this.$store.dispatch('getPage', this.name + '_' + this.$store.state.i18n.locale).then(content => {
                    this.content = content
                    this.loaded = true
                })
            }, 500)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/modalPage/modalPage.js